<div class="menu-item" *ngFor="let item of asideMenu">

  <!-- type: single -->
  <div class="menu-item" *ngIf="item.type === 'single' && (item.permissions | permission)" (click)="setActiveItem(item)">
    <a class="menu-link without-sub" [routerLink]="item.path" routerLinkActive="active"><span class="menu-icon">
        <span [inlineSVG]="'./assets/media/icons/duotune/' + item.icon" class="svg-icon svg-icon-2"></span>
      </span>
      <span class="menu-title hover">{{item.name}}</span></a>
  </div>

  <!-- type: separator -->
  <div class="menu-item" *ngIf="item.type === 'separator' && (item.permissions | permission)">
    <div class="menu-content">
      <div class="separator mx-1 my-4"></div>
    </div>
  </div>

  <!-- type: label -->
  <div class="menu-item" *ngIf="item.type === 'label' && (item.permissions | permission)">
    <div class="menu-content pb-2">
      <span class="menu-section text-muted text-uppercase fs-8 ls-1 text-bold" >{{item.name}}</span>
    </div>
  </div>

  <!-- type: dropdown -->
  <div class="menu-item menu-accordion" data-kt-menu-trigger="click" routerLinkActive="here show"
    *ngIf="item.type === 'dropdown' && (item.permissions | permission)">
    <span class="menu-link" [ngClass]="{'text-primary active': activeItem === item}">
      <span class="menu-icon">
        <span class="svg-icon svg-icon-2" [inlineSVG]="'./assets/media/icons/duotune/' + item.icon"></span>
      </span>
      <span class="menu-title hover" [attr.data-link]="item.dataLink"
        >{{item.name}}</span><span class="menu-arrow"></span>
    </span>
    <div class="menu-sub menu-sub-accordion" routerLinkActive="menu-active-bg" *ngIf="item?.items?.length">
      <div class="menu-item" *ngFor="let dropdownItem of item?.items" (click)="setActiveItem(item)" >
        <a class="menu-link without-sub" routerLinkActive="active" [routerLink]="dropdownItem.path" *ngIf="dropdownItem.permissions | permission"><span
            class="menu-bullet"><span class="bullet bullet-dot"></span></span><span
            class="menu-title hover">{{dropdownItem.name}}</span></a>
      </div>
    </div>
  </div>

</div>
